import React from "react";
import { Link } from "react-router-dom";
import "../../styles/productcard.css";
import Constant from "../../helper/Constant";
import { buildProductDetailsPath } from "../../helper/productUrl";
import axios from "axios";
import toast from "react-hot-toast";

const getGuestCartId = () => {
  let guestCartId = localStorage.getItem("guestCartId");

  if (!guestCartId) {
    guestCartId = `guest_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("guestCartId", guestCartId);
  }

  return guestCartId;
};

const BestSellingProducts = ({ product }) => {
  const {
    _id,
    image = product.images && product.images.length > 0
      ? Constant.imageDomain + product.images[0]
      : "",
    name,
    offer_price,
    price,
    highlight,
  } = product;

  const productPath = buildProductDetailsPath(product);
  const displayPrice = offer_price > 0 ? offer_price : price;
  const hasOffer = offer_price > 0 && price > offer_price;

  const handleAddToCart = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const token = localStorage.getItem("token");

    // if (!token) {
    //   localStorage.setItem("redirectAfterLogin", window.location.pathname);
    //   toast.error("Please login first");
    //   setTimeout(() => (window.location.href = "/login"), 1200);
    //   return;
    // }

    const variantList = product.variants || product.variant || [];
    const variantId = variantList[0]?._id || "";

    try {
      const fd = new FormData();
      fd.append("product_id", _id);
      fd.append("variant_id", variantId);
      fd.append("quantity", 1);

      if (!token) {
        fd.append("guest_id", getGuestCartId());
      }

      await axios.post(Constant.postUrls.addToCart, fd, {
        headers: token ? { Authorization: token } : {},
      });

      toast.success("Added to cart");
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to add to cart");
    }
  };

  return (
    <div className="product-card-link">
      <div
        className={`product-card best-selling-product-card ${
          highlight ? "highlight" : ""
        }`}
      >
        <Link to={productPath} className="best-selling-card-link">
          {hasOffer && (
            <div className="discount-badge">
              {Math.round(((price - offer_price) / price) * 100)}% OFF
            </div>
          )}

          <div className="product-image-wrapper">
            <img src={image} alt={name} />
          </div>

          <div className="product-details">
            <h4 className="product-title">{name}</h4>
          </div>
        </Link>

        <div className="best-selling-card-footer">
          <div className="best-selling-price-box">
            <div className="price-row">
              <span className="price">₹{displayPrice}</span>
              {hasOffer && <span className="mrp">₹{price}</span>}
            </div>

            {hasOffer && (
              <div className="save-text">Save ₹{price - offer_price}</div>
            )}
          </div>

          <button className="best-selling-add-cart" onClick={handleAddToCart}>
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default BestSellingProducts;
